export default {"src":"/_next/static/media/zoom.49399437.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};